export const ArrowRight = ({ width, height, viewBox, fill, styles }) => {
  return (
    <svg
      width={width || '24'}
      height={height || '24'}
      viewBox={viewBox || '0 0 24 24'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles}
    >
      <path
        d="M7.84 7.41L12.42 12L7.84 16.59L9.25 18L15.25 12L9.25 6L7.84 7.41Z"
        fill={fill || '#BBBEC6'}
      />
    </svg>
  );
};
